module.exports = __webpack_public_path__ + "static/media/shipt-3.22afb0f8.jpg";